import { signInWithEmailAndPassword } from "firebase/auth";
import React, { FC, useState } from "react";
import {
  InputText,
  ShadowContainer,
  Button,
  Container,
  Label,
} from "../../components";

import { auth } from "../../firebase/firebase-core";

interface FieldParamaters {
  error?: string;
  minLength?: number;
  isMandatory: boolean;
  regexPattern?: RegExp;
  value: string;
}

interface UserLogin {
  email: FieldParamaters;
  password: FieldParamaters;
}

const Login: FC = () => {
  const validateForm = () => {
    const { email, password } = loginFormValues;
    email.error = "";
    password.error = "";

    if (email.isMandatory && email.value?.length === 0) {
      email.error = "O e-mail é obrigatório";
    } else if (!email.regexPattern?.test(email.value)) {
      email.error = "O e-mail possui formato inválido, por favor verifique";
    }

    if (password.isMandatory && password.value?.length === 0) {
      password.error = "A senha é obrigatória";
    }

    setLoginFormValues({ ...loginFormValues });
  };

  const login = () => {
    const { email, password } = loginFormValues;
    signInWithEmailAndPassword(auth, email.value, password.value)
      .then((userCredential) => {})
      .catch((error) => {
        if (error.message) {
          setGeneralError("*Usuário e ou senha inválidos");
        }
      });
  };

  const initialValues: UserLogin = {
    email: {
      isMandatory: true,
      regexPattern:
        /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i,
      value: "",
    },
    password: {
      minLength: 6,
      isMandatory: true,
      value: "",
    },
  };

  const [loginFormValues, setLoginFormValues] =
    useState<UserLogin>(initialValues);
  const [generalError, setGeneralError] = useState<string>("");

  const handleChangeEmail = (e: any) => {
    const { email } = loginFormValues;
    email.value = e.currentTarget.value;
    setLoginFormValues({ ...loginFormValues });
  };

  const handleChangePassword = (e: any) => {
    const { password } = loginFormValues;
    password.value = e.currentTarget.value;
    setLoginFormValues({ ...loginFormValues });
  };

  const handleSubmit = (e: any) => {
    e.preventDefault();
    setGeneralError("");
    validateForm();
    const { email, password } = loginFormValues;

    if (email.error?.length === 0 && password.error?.length === 0) {
      login();
    }
  };

  return (
    <Container>
      {" "}
      <form
        onSubmit={handleSubmit}
        style={{ display: "flex", justifyContent: "center", width: "inherit" }}
      >
        <ShadowContainer>
          <h1> Login - Basta Trânsito</h1>
          <p>
            Olá, seja bem vindo ao aplicativo web Basta Trânsito. <br />
            <br />
            Por gentileza informe as suas credenciais para acesso ao sistema:
          </p>
          E-mail:
          <InputText
            isPassword={false}
            onChange={handleChangeEmail}
            error={loginFormValues.email.error}
            autofocus={true}
          />
          {loginFormValues.email.error && (
            <Label errorMessage={"*" + loginFormValues.email.error} />
          )}
          <br />
          Senha:
          <InputText
            isPassword={true}
            onChange={handleChangePassword}
            error={loginFormValues.password.error}
          />
          {loginFormValues.password.error && (
            <Label errorMessage={"*" + loginFormValues.password.error} />
          )}
          <br />
          {generalError && <Label errorMessage={generalError} />}
          <Button text="Entrar" />
        </ShadowContainer>
      </form>
    </Container>
  );
};

export default Login;
